// extracted by mini-css-extract-plugin
export var breakDesc = "index-module--breakDesc---IFZP";
export var cardheader = "index-module--cardheader--VSLgh";
export var contetnWrapper = "index-module--contetnWrapper--45UoW";
export var desc = "index-module--desc--1k4s6";
export var icon = "index-module--icon--kav09";
export var productCardWrapper = "index-module--productCardWrapper--38yNB";
export var smallIcon = "index-module--smallIcon--+yStT";
export var title = "index-module--title--Q08fm";
export var wrapper = "index-module--wrapper--V4j-G";